import React from 'react';
import { Helmet } from 'react-helmet';
import { isRollout0Feature } from '../../config/featureFlags';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = "Lemay Roofing - Avon Park's Trusted Roofing Experts | 30+ Years Experience",
  description = "Professional roofing services in Avon Park, FL. Over 30 years of experience in roof repair, replacement, and installation. Free estimates. Licensed & insured. Call (863) 658-0229",
  keywords = "roofing Avon Park, roof repair, roof replacement, roofing contractor, Highlands County roofer, Lake Placid roofing, Sebring roofing",
  canonical = "https://lemayroofinginc.com"
}) => {
  if (!isRollout0Feature('seoMetaTags')) {
    return null;
  }

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* OpenGraph Meta Tags */}
      <meta property="og:type" content="business.business" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${canonical}/favicon.ico`} />
      <meta property="og:site_name" content="Lemay Roofing" />
      <meta property="og:locale" content="en_US" />

      {/* Business Schema */}
      <meta property="business:contact_data:street_address" content="Avon Park" />
      <meta property="business:contact_data:locality" content="Avon Park" />
      <meta property="business:contact_data:region" content="FL" />
      <meta property="business:contact_data:postal_code" content="33825" />
      <meta property="business:contact_data:country_name" content="USA" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Local Business JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "RoofingContractor",
          "name": "Lemay Roofing",
          "image": `${canonical}/favicon.ico`,
          "telephone": "(863) 658-0229",
          "email": "lemayroofing@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Avon Park",
            "addressLocality": "Avon Park",
            "addressRegion": "FL",
            "postalCode": "33825",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "27.5964",
            "longitude": "-81.5059"
          },
          "url": canonical,
          "priceRange": "$$",
          "areaServed": [
            "Avon Park, FL",
            "Lake Placid, FL",
            "Sebring, FL",
            "Wauchula, FL",
            "Highlands County, FL"
          ],
          "serviceType": ["Roof Repair", "Roof Replacement", "Roof Installation", "Storm Damage Repair"],
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "150"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;
